const liff = {
    error: '',
    ready: true,
    init: async () => {},
    openWindow: async () => {},
    shareTargetPicker: async () => {},
    getDecodedIDToken: () => ({ phone_number: '0912345678' }),
    isLoggedIn: () => true,
    isInClient: () => false,
    getFriendship: async () => ({ friendFlag: false }),
    getProfile: async () => ({
        userId: 'U2680acfff544145a7db1495e2a087c4c',
        displayName: '陳品碩 Peter',
        statusMessage: 'じゅえん',
        pictureUrl:
            'https://profile.line-scdn.net/0hDLs-oSveG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRVRnYlw1czRcgg'
    }),
    getAccessToken: () =>
        'eyJhbGciOiJIUzI1NiJ9.DJnITssZqAwy9vdA4mPtBlSsmYtYUnM34wLEOFYCuVhctOgJg5mf1BXiOWAWI8cGwJR7eskqZ_MYbX7r3Z8Zczlj8kBokGyxRbOu1lB2q3ZhoZcWukUFwp7EuZAexYyXpmWfCY8_29nrbfbN2KZ1q56M5z2J3Y6J3LnojzUXt04.W4rqe-MMLRydDs_iyj_44ySeuxnJH8Q5xqF3uE_I9no'
};
export default liff;
